var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33.397,
    viewBox: "0 0 32 33.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29509",
    "data-name": "Group 29509",
    transform: "translate(-0.205)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13384",
    "data-name": "Rectangle 13384",
    width: 32,
    height: 32,
    transform: "translate(0.205)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pen-tool",
    transform: "translate(16.187 0.426) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50166",
    "data-name": "Path 50166",
    d: "M12,19.124,19.124,12l3.053,3.053-7.124,7.124Z",
    transform: "translate(0.137 0.137)",
    fill: "none",
    stroke: "#adadad",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50167",
    "data-name": "Path 50167",
    d: "M18.283,13.195,16.757,5.562,2,2,5.562,16.757l7.633,1.527Z",
    fill: "none",
    stroke: "#adadad",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50168",
    "data-name": "Path 50168",
    d: "M2,2,9.72,9.72",
    fill: "none",
    stroke: "#adadad",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1013",
    "data-name": "Ellipse 1013",
    cx: 2.257,
    cy: 2.257,
    r: 2.257,
    transform: "translate(8.774 8.774)",
    fill: "none",
    stroke: "#adadad",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.956dd6d6.svg";
export { ForwardRef as ReactComponent };